<script lang="js">
  import Collection from "./Collection.svelte";
  import Standalone from "./Standalone.svelte";
  import FABContainerMain from "../helper/container-main";
  let { by_position } = window.FAB_PLUGIN;
</script>

{#each Object.entries(by_position) as [position, items]}
  <div
    class:hidden={FABContainerMain.isMainContainerHidden()}
    class={FABContainerMain.getMainContainerClass(position)}
    style={FABContainerMain.getMainContainerStyle()}
  >
    <Collection {position} to_display={items.filter((i) => i.isButton && i.standalone !== "yes")} />
    <Standalone standalones={items.filter((i) => i.isButton && i.standalone === "yes")} />
  </div>
{/each}
